import { api } from "@/api"

const { setToken } = useMerchantGroupAuth()

type LogInMerchantGroupAdminBody = {
  email: string
  password: string
}

type LogInMerchantGroupAdminResponse = {
  accessToken: string
}

export const logInMerchantGroupAdmin = async (
  params: LogInMerchantGroupAdminBody
) => {
  const { body } =
    await api.post<LogInMerchantGroupAdminResponse>(
      "/merchant-group/login-merchant-group-admin/",
      {
        body: params,
        authenticated: false,
      }
    )

  setToken(body.accessToken)
}
